import React, { useState, useEffect, useRef } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";


import mobileLogo from "../assets/logga.png";
import navimg from "../assets/rusty.jpg"
import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const { t, i18n } = useTranslation();
  const location = useLocation();

  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);

  const currentLang = i18n.language;
  const switchLanguage = (lang) => i18n.changeLanguage(lang);


  const lightPages = ["/alla-fastigheter", "/soldObjects", "/peter"];
  const isLightPage = lightPages.includes(location.pathname);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [menuOpen]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navbarClass = [
    "navbar",
    isScrolled && "navbar--scrolled",
    isLightPage && "navbar--light",
    menuOpen && "navbar--open",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <nav className={navbarClass}>
      
      <div
        className={`hamburger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
        ref={hamburgerRef}
      >
        <span />
        <span />
        <span />
      </div>

      <div className="navbar-logo-wrapper">
        <RouterLink
          to="/"
          onClick={() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            setMenuOpen(false);
          }}
        >
          <img src={mobileLogo} className="mobile-logo" alt="Logo" />
        </RouterLink>
      </div>

      <div className="navbar-right-container">
   

        <div className="language-switcher desktop-only">
          <span
            className={currentLang === "sv" ? "active" : ""}
            onClick={() => switchLanguage("sv")}
          >
            Sv
          </span>
          <span className="separator">|</span>
          <span
            className={currentLang === "en" ? "active" : ""}
            onClick={() => switchLanguage("en")}
          >
            En
          </span>
        </div>
      </div>

      <div className={`navbar-links mobile ${menuOpen ? "open" : ""}`} ref={menuRef}>
          <div className="nav-menu-content">
            <div className="nav-menu-sidebar">
              <div className="language-switcher-mobile">
                <span onClick={() => switchLanguage("sv")} className={currentLang === "sv" ? "active" : ""}>SV</span>
                <span onClick={() => switchLanguage("en")} className={currentLang === "en" ? "active" : ""}>EN</span>
              </div>
            </div>
  
            <ul className="nav-main-links">
              <li><RouterLink to="/" onClick={() => setMenuOpen(false)}>{t("nav.home")}</RouterLink></li>
              <li><RouterLink to="/alla-fastigheter" onClick={() => setMenuOpen(false)}>{t("nav.properties")}</RouterLink></li>
              <li><RouterLink to="/peter" onClick={() => setMenuOpen(false)}>{t("nav.philosophy")}</RouterLink></li>
              <li><RouterLink to="/contact" onClick={() => setMenuOpen(false)}>{t("nav.contact")}</RouterLink></li>
              <li><RouterLink to="/buyhome" onClick={() => setMenuOpen(false)}>{t("nav.sellWithUs")}</RouterLink></li>
            </ul>
  
            <div className="nav-menu-featured-img">
              <img src={navimg} alt="Featured Interior" />
            </div>
          </div>
  
          <div className="nav-mobile-footer">
            <a href="mailto:peter@olvsborn.se">peter@dinmaklareahus.se</a>
            <div className="nav-socials-minimal">
              <a href="https://www.instagram.com/dinmaklareahus/?__d=1" target="_blank" rel="noreferrer">Instagram</a>
            </div>
          </div>
        </div>
    </nav>
  );
};

export default Navbar;